// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__an9tT","additionalInfo":"AgreementModal_additionalInfo__1FFIp"};